module.exports = __webpack_public_path__ + "static/fiona-89c11b5454a5a7f312a495ddef59d2d0.jpg";